import { ApiServiceBase } from '../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Observable } from 'rxjs';
import { LanguageReferenceModel } from 'src/app/core/models/reference-model/reference-media-model';

@Injectable({
  providedIn: 'root'
})
export class LanguageReferenceService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/airline"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getByOrganisation(): Observable<LanguageReferenceModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH + "/languagereference/organisation", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }

}